import styled from '@emotion/styled/macro';
import vars from '@variables';
import { Link } from 'gatsby';
import { shouldForwardProp } from '@utils/utils';

type StyledLinkProps = {
  isExternal?: boolean;
};

export const FooterWrapper = styled.div`
  background-color: #2f2f46;
  padding: ${vars.spacingM} 0;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08),
    0px 4px 6px -2px rgba(16, 24, 40, 0.03);
`;

export const LinksContainer = styled.div`
  max-width: ${vars.mainMaxWidth};
  margin: 0 auto;
  padding: 0 ${vars.spacingL};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLink = styled(Link, {
  shouldForwardProp: prop => shouldForwardProp(['isExternal'], prop),
})<StyledLinkProps>(({ isExternal }) => {
  return `
    font-weight: ${vars.fontWeightRegular};
    margin: 0 ${vars.spacingL};
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    color: #ccc;
    text-decoration:none;
    
    ${
      isExternal &&
      `
      margin-left: 0;
    `
    }
    
    &:first-of-type {
      margin-left: 0;
    }
    &:last-of-type {
      margin-right: 0;
    }
  `;
});

export const Align = styled.div`
  display: flex;
  align-items: center;
`;

export const Newsletter = styled.div`
  display: flex;
  font-weight: ${vars.fontWeightRegular};
  margin-left: ${vars.spacingS};
  color: #ccc;

  a {
    margin-left: ${vars.spacingS};
    text-decoration: underline;
  }
`;
